import { UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const quizStepSchema = {
    displayName: 'Quiz Step',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        name: {
            type: 'shortString',
            required: true,
            writeRight: UserRight.BiteSupport,
        },
        displayTitle: {
            displayName: 'Display Title',
            type: 'shortString',
            writeRight: UserRight.BiteSupport,
            canHaveLocalizationOverrides: true,
        },
        badgeIds: {
            type: 'array',
            elementType: 'mongoId',
            displayName: 'Badges',
            ui: 'checklist',
            canCreateNew: true,
            writeRight: UserRight.BiteSupport,
        },
        minSelections: {
            displayName: 'Minimum Selections',
            type: 'int',
            min: 0,
            tooltip: {
                text: 'The minimum number of selections for this step.',
            },
            writeRight: UserRight.BiteSupport,
        },
        maxSelections: {
            displayName: 'Maximum Selections',
            type: 'int',
            min: 1,
            tooltip: {
                text: 'The maximum number of selections allowed for this step. Leave blank for no maximum.',
            },
            writeRight: UserRight.BiteSupport,
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
    },
};
//# sourceMappingURL=quiz_step_schema.js.map